export default __webpack_public_path__ + "static/media/1.f4c14ad4.webp";